import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';
import type { TaskSaveRequest } from 'tm3-core/api.dtos';
import { TaskResponse } from 'tm3-core/api.dtos';

export class TaskUpdateEvent implements IEvent {
  task: TaskResponse = new TaskResponse();
  isNew: boolean = false;
  isDeleted: boolean = false;

  public constructor(init?: Partial<TaskUpdateEvent>) {
    (Object as any).assign(this, init);
  }
}

export class AddTaskEvent implements IEvent {
  patientId?: number;
  patientName?: string;
  title?: string;
  description?: string;
  dueDate?: string;
  targetType?: string;
  targetId?: number;
  checklistTemplateId?: number;
  startCustomChecklist?: boolean;
  /**
   * When provided, the Add Task dialog runs in draft mode: instead of POSTing
   * the assembled TaskSaveRequest immediately, it invokes this callback so the
   * caller (e.g. the new-appointment screen) can hold the draft until the
   * parent record is created. Existing call sites that omit it keep the
   * legacy immediate-save behaviour.
   */
  onDraftSave?: (dto: TaskSaveRequest) => void;
  /** Optional stable key used when seeding drafts from auto-rule templates. */
  draftOriginKey?: string;

  public constructor(init?: Partial<AddTaskEvent>) {
    (Object as any).assign(this, init);
  }
}

export class AddCaseChecklistTemplateEvent implements IEvent {
  caseId?: number;

  public constructor(init?: Partial<AddCaseChecklistTemplateEvent>) {
    (Object as any).assign(this, init);
  }
}
